import registration from '@views/registration';

export default {
    path: '/registration',
    name: 'registration',
    component: registration,
    meta: {
        guest: true
    }
};